import {
  GeckoAnalyticsProvider,
  useGeckoAnalytics,
} from './GeckoAnalyticsProvider'

export { GeckoAnalyticsProvider, useGeckoAnalytics }

export const SELECT_COMPONENT = {
  title: 'Select Component',
  description: 'Selected Component on Details Page',
}
export const SELECT_INSPECTION = {
  title: 'Select Inspection',
  description: 'Selected Inspection on Details Page',
}
export const LOGIN = {
  title: 'Log In Forecast',
  description: 'Log In to Forecast',
}
export const LOAD_DETAILS_PAGE = {
  title: 'Details Page',
  description: 'Loaded Asset Viz',
}
export const DOWNLOAD_FILE = {
  title: 'Download File',
  description: 'Downloaded File from Details Page',
}
export const SELECT_ALGORITHM = {
  title: 'Select Algorithm',
  description: 'Selected an Algorithm in Advanced Controls',
}
export const SELECT_AGGREGATION = {
  title: 'Select Aggregation',
  description: 'Selected an Aggregation in Advanced Controls',
}
export const SELECT_ANGLE_PLOT = {
  title: 'Select Angle Plot',
  description: 'Selected an Angle Plot Setting in Advanced Controls',
}
export const SELECT_T_MIN_METHOD = {
  title: 'Select T-Min Method',
  description: 'Selected a T-min Method in Advanced Controls',
}
export const SELECT_DEPTH = {
  title: 'Select Depth',
  description: 'Selected a Depth Range in Left Sidebar',
}
export const SELECT_BIN_SIZE = {
  title: 'Select Bin Size',
  description: 'Selected an Bin Size in Advanced Controls',
}
export const SELECTED_VIEW = {
  title: 'Select Data View',
  description: 'Selected a different Data View Than Default',
}

export const ENTITY_EDIT = {
  title: 'Entity Edit',
  description: 'User started editing an entity',
}

export const ENTITY_CANCEL_EDIT = {
  title: 'Entity Cancel Edit',
  description: 'User canceled editing an entity',
}

export const ENTITY_SAVE = {
  title: 'Entity Save',
  description: 'Entity save operation attempted',
}
